// Gerencia o estado do usuário autenticado e fornece métodos de autenticação para toda a aplicação.
// Utiliza funções de API do arquivo authApi.ts.
// Usa JwtAuthContext.Provider para fornecer os métodos e estado de autenticação para os componentes filhos.

import { useState, useEffect } from 'react';
import JwtAuthContext from './JwtAuthContext';
import { authSignIn, authSignUp, authRefreshToken } from '../../../auth/services/authApi';
import { User } from '../../user';

const JwtAuthProvider = ({ children }: { children: React.ReactNode }) => {
	const [user, setUser] = useState<User | null>(null);

	// Se houver um token armazenado, tenta renovar o token usando authRefreshToken().
	useEffect(() => {
		const token = localStorage.getItem('jwt_token');
		if (token) {
			authRefreshToken().then(setUser);
		}
	}, []);

	
	const signIn = async (email: string, password: string) => {
		try {
		  const authenticatedUser = await authSignIn(email, password);
	  
		  if (!authenticatedUser || !authenticatedUser.access_token) {
			throw new Error("Credenciais inválidas");
		  }
	  
		  setUser(authenticatedUser.user); // Definir somente os dados do usuário
	  
		  // Armazena os tokens no LocalStorage
		  localStorage.setItem("jwt_token", authenticatedUser.access_token);
		  localStorage.setItem("refresh_token", authenticatedUser.refresh_token);
		} catch (error) {
		  console.error("Erro ao fazer login:", error);
		  throw new Error("Usuário ou senha incorretos."); // Garantir que o erro seja tratado no SignIn.tsx
		}
	};
	    
	  
	// Cria um usuário e armazena o token.
	const signUp = async (email: string, password: string, firstName: string, lastName: string) => {
		try {
		const newUser = await authSignUp(email, password, firstName, lastName);
		setUser(newUser);
		localStorage.setItem("jwt_token", newUser.access_token);
		localStorage.setItem("refresh_token", newUser.refresh_token);
		} catch (error) {
		console.error("Erro ao criar conta:", error);
		}
	};
  

	// Remove o usuário e apaga o token do localStorage.
	const signOut = () => {
		setUser(null);
		localStorage.removeItem("jwt_token");
		localStorage.removeItem("refresh_token");
	  };

	// Renova o token de autenticação.
	const refreshToken = async () => {
		const refreshedUser = await authRefreshToken();
		setUser(refreshedUser);
	};

	//Usa JwtAuthContext.Provider para fornecer os métodos e estado de autenticação para os componentes filhos.
	return (
		<JwtAuthContext.Provider value={{ user, signIn, signUp, signOut, refreshToken }}>
			{children}
		</JwtAuthContext.Provider>
	);
};

export default JwtAuthProvider;
